import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import {
  getAttendanceDetail,
} from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";

const StatusBadge = ({ status }) => {
  const isPresent = String(status).toLowerCase() === "present";
  return (
    <span
      className="badge"
      style={{
        background: isPresent ? "#d4edda" : "#f8d7da",
        color: isPresent ? "#155724" : "#721c24",
        fontWeight: 600,
        fontSize: "12px",
        padding: "4px 10px",
        borderRadius: "6px",
      }}
    >
      {isPresent ? "Present" : "Absent"}
    </span>
  );
};

const AttendanceDetailModal = ({ show, onHide, trainingId, date, trainingName }) => {
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(false);
  const showDateCol = !date;

  const handleExportCsv = () => {
    const headers = showDateCol
      ? ['Athlete Name', 'Atom ID', 'Session Date', 'Status', 'Marked By']
      : ['Athlete Name', 'Atom ID', 'Status', 'Marked By'];

    const rows = athletes.map((a) => {
      const base = [
        a.athlete_name || a.name || '',
        a.atom_id || '',
      ];
      if (showDateCol) base.push(a.session_date || '');
      base.push(a.status || '', a.marked_by_name || a.marked_by || '');
      return base;
    });

    const csvContent = [headers, ...rows]
      .map((r) => r.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `attendance_${trainingName || trainingId}${date ? `_${date}` : ''}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (!show || !trainingId) return;

    setLoading(true);
    setAthletes([]);
    getAttendanceDetail(trainingId, date || null)
      .then((res) => {
        const data = res?.data?.data;
        setAthletes(Array.isArray(data) ? data : []);
      })
      .catch(() => setAthletes([]))
      .finally(() => setLoading(false));
  }, [show, trainingId, date]);

  const colSpan = showDateCol ? 5 : 4;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton style={{ borderBottom: "1px solid #f0f0f0" }}>
        <Modal.Title style={{ fontSize: "16px", fontWeight: 700 }}>
          Attendance — {trainingName || "Training"}{date ? ` (${date})` : ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 0 }}>
        <table className="table mb-0">
          <thead>
            <tr style={{ background: "#8757e8" }}>
              <th className="text-white fw-semibold py-3 px-4">Athlete Name</th>
              <th className="text-white fw-semibold py-3 px-4">ID</th>
              {showDateCol && <th className="text-white fw-semibold py-3 px-4">Session Date</th>}
              <th className="text-white fw-semibold py-3 px-4">Status</th>
              <th className="text-white fw-semibold py-3 px-4">Marked By</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={colSpan} className="text-center py-4">Loading...</td>
              </tr>
            ) : athletes.length > 0 ? (
              athletes.map((athlete, idx) => (
                <tr key={`${athlete.atom_id}-${idx}`} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td className="py-3 px-4 fw-semibold">{athlete.athlete_name || athlete.name || "—"}</td>
                  <td className="py-3 px-4">{athlete.atom_id || "—"}</td>
                  {showDateCol && <td className="py-3 px-4">{athlete.session_date || "—"}</td>}
                  <td className="py-3 px-4">
                    <StatusBadge status={athlete.status} />
                  </td>
                  <td className="py-3 px-4">{athlete.marked_by_name || athlete.marked_by || athlete.coach_name || "—"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={colSpan} className="text-center py-4">No attendance records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <button
          className="btn btn-sm"
          style={{ background: "#28a745", color: "#fff", borderRadius: "8px" }}
          onClick={handleExportCsv}
          disabled={athletes.length === 0 || loading}
        >
          ⬇ Export CSV
        </button>
        <button
          className="btn btn-sm"
          style={{ background: "#8757e8", color: "#fff", borderRadius: "8px" }}
          onClick={onHide}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AttendanceDetailModal;
